// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__wYR8G","messages":"Chat_messages__2Ly-V","dateDivider":"Chat_dateDivider__1d3Qu"};